import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import classnames from "classnames";
import { Box } from "../../../../Box/index.js";
import { Badge, Preloader } from "../../../common/index.js";
import { Icon } from "../../../../Icon/index.js";
import { Group } from "../common/index.js";
import SelectInput_styles from "../../SelectInput.styles.js";
import { PopupIcon } from "../../PopupIcon/index.js";
import { Option } from "./Option/index.js";
import { COLORS } from "./constants.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function SingleAutocomplete_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else SingleAutocomplete_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const SingleAutocomplete = (t0)=>{
    const $ = c(83);
    let emptyOption;
    let handlePopoverOpen;
    let helperText;
    let inputId;
    let inputValue;
    let isThereSomeGroup;
    let items;
    let label;
    let onChange;
    let onFocus;
    let placeholder;
    let renderOption;
    let rest;
    let setInputValue;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let valueBadge;
    let valueColorIndicator;
    if ($[0] !== t0) {
        ({ label, value, items, onChange, disabled: t1, placeholder, testId, clearable: t2, loading: t3, error: t4, helperText, renderOption, emptyOption, inputValue, setInputValue, isThereSomeGroup, inputId, handlePopoverOpen, valueBadge, valueColorIndicator, onFocus } = t0), rest = _object_without_properties(t0, [
            "label",
            "value",
            "items",
            "onChange",
            "disabled",
            "placeholder",
            "testId",
            "clearable",
            "loading",
            "error",
            "helperText",
            "renderOption",
            "emptyOption",
            "inputValue",
            "setInputValue",
            "isThereSomeGroup",
            "inputId",
            "handlePopoverOpen",
            "valueBadge",
            "valueColorIndicator",
            "onFocus"
        ]);
        $[0] = t0;
        $[1] = emptyOption;
        $[2] = handlePopoverOpen;
        $[3] = helperText;
        $[4] = inputId;
        $[5] = inputValue;
        $[6] = isThereSomeGroup;
        $[7] = items;
        $[8] = label;
        $[9] = onChange;
        $[10] = onFocus;
        $[11] = placeholder;
        $[12] = renderOption;
        $[13] = rest;
        $[14] = setInputValue;
        $[15] = t1;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = testId;
        $[20] = value;
        $[21] = valueBadge;
        $[22] = valueColorIndicator;
    } else {
        emptyOption = $[1];
        handlePopoverOpen = $[2];
        helperText = $[3];
        inputId = $[4];
        inputValue = $[5];
        isThereSomeGroup = $[6];
        items = $[7];
        label = $[8];
        onChange = $[9];
        onFocus = $[10];
        placeholder = $[11];
        renderOption = $[12];
        rest = $[13];
        setInputValue = $[14];
        t1 = $[15];
        t2 = $[16];
        t3 = $[17];
        t4 = $[18];
        testId = $[19];
        value = $[20];
        valueBadge = $[21];
        valueColorIndicator = $[22];
    }
    const disabled = void 0 === t1 ? false : t1;
    const clearable = void 0 === t2 ? false : t2;
    const loading = void 0 === t3 ? false : t3;
    const error = void 0 === t4 ? false : t4;
    const { classes } = SelectInput_styles();
    const t5 = !!renderOption;
    let t6;
    if ($[23] !== classes.autocompleteList || $[24] !== classes.list || $[25] !== classes.longList || $[26] !== t5) {
        t6 = classnames(classes.list, classes.autocompleteList, {
            [classes.longList]: t5
        });
        $[23] = classes.autocompleteList;
        $[24] = classes.list;
        $[25] = classes.longList;
        $[26] = t5;
        $[27] = t6;
    } else t6 = $[27];
    let t7;
    if ($[28] !== t6) {
        t7 = {
            paper: t6
        };
        $[28] = t6;
        $[29] = t7;
    } else t7 = $[29];
    const inputClasses = t7;
    let t8;
    if ($[30] !== loading) {
        t8 = loading ? {
            slotProps: {
                input: {
                    endAdornment: /*#__PURE__*/ jsx(Preloader, {})
                }
            }
        } : {};
        $[30] = loading;
        $[31] = t8;
    } else t8 = $[31];
    const loadingInputProps = t8;
    let t9;
    if ($[32] !== inputValue || $[33] !== loading || $[34] !== valueBadge) {
        t9 = inputValue && valueBadge && !loading ? {
            slotProps: {
                input: {
                    startAdornment: /*#__PURE__*/ jsx(Badge, {
                        title: valueBadge.title,
                        description: valueBadge.description,
                        color: valueBadge.color
                    })
                }
            }
        } : {};
        $[32] = inputValue;
        $[33] = loading;
        $[34] = valueBadge;
        $[35] = t9;
    } else t9 = $[35];
    const inputValueBadgeProps = t9;
    const groupBy = _temp;
    let t10;
    if ($[36] !== isThereSomeGroup) {
        t10 = isThereSomeGroup ? {
            groupBy
        } : {};
        $[36] = isThereSomeGroup;
        $[37] = t10;
    } else t10 = $[37];
    const groupProps = t10;
    let t11;
    if ($[38] !== inputValue || $[39] !== loading || $[40] !== valueBadge || $[41] !== valueColorIndicator) {
        t11 = (params)=>inputValue && valueColorIndicator && !valueBadge && !loading ? {
                InputProps: _object_spread_props(_object_spread({}, params.InputProps), {
                    startAdornment: /*#__PURE__*/ jsx(Box, {
                        width: 8,
                        height: 8,
                        ml: "16",
                        bgcolor: COLORS[valueColorIndicator],
                        radius: "round"
                    })
                })
            } : {};
        $[38] = inputValue;
        $[39] = loading;
        $[40] = valueBadge;
        $[41] = valueColorIndicator;
        $[42] = t11;
    } else t11 = $[42];
    const getInputColorIndicator = t11;
    let t12;
    if ($[43] !== items || $[44] !== value) {
        t12 = items.find((option)=>option.value === value) || null;
        $[43] = items;
        $[44] = value;
        $[45] = t12;
    } else t12 = $[45];
    const t13 = loading ? "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : inputValue;
    const t14 = disabled || loading;
    const t15 = !clearable;
    let t16;
    let t17;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsx(PopupIcon, {
            mx: "12"
        });
        t17 = /*#__PURE__*/ jsx(Icon, {
            name: "dismiss_substract",
            color: "stroke.secondary",
            size: "24"
        });
        $[46] = t16;
        $[47] = t17;
    } else {
        t16 = $[46];
        t17 = $[47];
    }
    const t18 = emptyOption || "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E";
    let t19;
    if ($[48] !== setInputValue) {
        t19 = (_, nextValue)=>{
            setInputValue(nextValue);
        };
        $[48] = setInputValue;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== onChange) {
        t20 = (__0, nextValue_0)=>{
            onChange(null == nextValue_0 ? void 0 : nextValue_0.value);
        };
        $[50] = onChange;
        $[51] = t20;
    } else t20 = $[51];
    let t21;
    if ($[52] !== inputValue || $[53] !== renderOption) {
        t21 = (props, option_2)=>/*#__PURE__*/ jsx(Option, {
                inputValue: inputValue,
                renderOption: renderOption,
                optionProps: props,
                option: option_2
            });
        $[52] = inputValue;
        $[53] = renderOption;
        $[54] = t21;
    } else t21 = $[54];
    let t22;
    if ($[55] !== classes.inputRoot || $[56] !== error || $[57] !== getInputColorIndicator || $[58] !== handlePopoverOpen || $[59] !== helperText || $[60] !== inputId || $[61] !== inputValueBadgeProps || $[62] !== label || $[63] !== loadingInputProps || $[64] !== placeholder || $[65] !== rest) {
        t22 = (params_1)=>/*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest, params_1, loadingInputProps, inputValueBadgeProps, getInputColorIndicator(params_1)), {
                id: inputId,
                onClick: handlePopoverOpen,
                classes: {
                    root: `${classes.inputRoot} aqa_select`
                },
                variant: "outlined",
                placeholder: placeholder || label,
                error: error,
                helperText: helperText
            }));
        $[55] = classes.inputRoot;
        $[56] = error;
        $[57] = getInputColorIndicator;
        $[58] = handlePopoverOpen;
        $[59] = helperText;
        $[60] = inputId;
        $[61] = inputValueBadgeProps;
        $[62] = label;
        $[63] = loadingInputProps;
        $[64] = placeholder;
        $[65] = rest;
        $[66] = t22;
    } else t22 = $[66];
    let t23;
    if ($[67] !== groupProps || $[68] !== inputClasses || $[69] !== inputId || $[70] !== items || $[71] !== onFocus || $[72] !== t12 || $[73] !== t13 || $[74] !== t14 || $[75] !== t15 || $[76] !== t18 || $[77] !== t19 || $[78] !== t20 || $[79] !== t21 || $[80] !== t22 || $[81] !== testId) {
        t23 = /*#__PURE__*/ jsx(Autocomplete, _object_spread_props(_object_spread({}, groupProps), {
            id: inputId,
            blurOnSelect: true,
            "data-testid": testId,
            classes: inputClasses,
            value: t12,
            inputValue: t13,
            options: items,
            disabled: t14,
            disableClearable: t15,
            popupIcon: t16,
            clearIcon: t17,
            noOptionsText: t18,
            getOptionDisabled: _temp2,
            renderGroup: _temp3,
            getOptionLabel: _temp4,
            onInputChange: t19,
            onChange: t20,
            onFocus: onFocus,
            renderOption: t21,
            renderInput: t22
        }));
        $[67] = groupProps;
        $[68] = inputClasses;
        $[69] = inputId;
        $[70] = items;
        $[71] = onFocus;
        $[72] = t12;
        $[73] = t13;
        $[74] = t14;
        $[75] = t15;
        $[76] = t18;
        $[77] = t19;
        $[78] = t20;
        $[79] = t21;
        $[80] = t22;
        $[81] = testId;
        $[82] = t23;
    } else t23 = $[82];
    return t23;
};
function _temp(t0) {
    const { group } = t0;
    return group || "\u0417\u0430\u044F\u0432\u043A\u0438 \u0431\u0435\u0437 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438 \u043F\u043E \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044F\u043C";
}
function _temp2(option_0) {
    return !!option_0.disabled;
}
function _temp3(params_0) {
    return /*#__PURE__*/ jsx(Group, _object_spread({}, params_0));
}
function _temp4(option_1) {
    return option_1.label;
}
export { SingleAutocomplete };
